import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import TopicCard from "@/components/feature/TopicCard";
import { topics } from "@/mocks/topics";

export default function FeaturedTopics() {
  const featured = [...topics].sort((a, b) => b.heatScore - a.heatScore).slice(0, 6);

  return (
    <section className="w-full bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="高热度选题参考"
            title="这些方向，编辑正在等稿"
            desc="按热度与截止时间排序，每条都附上可切入的角度与标题参考。挑一个你手上够得着的方向动手。"
          />
          <Link
            to="/topics"
            className="inline-flex w-fit items-center gap-2 rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap cursor-pointer"
          >
            查看全部选题
            <i className="ri-arrow-right-line text-base leading-none"></i>
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {featured.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))}
        </div>
      </div>
    </section>
  );
}